import { api, unwrap } from './client';

export async function listCustomers() {
  const res = await api.get('/customer/all');
  const unwrapped = unwrap(res);
  if (!unwrapped) return [];
  if (Array.isArray(unwrapped)) return unwrapped;
  if (Array.isArray(unwrapped.content)) return unwrapped.content;
  return [];
}

export async function getCustomer(id) {
  const res = await api.get(`/customer/${id}`);
  return unwrap(res);
}

export async function listCustomersByType(type) {
  const res = await api.get(`/customer/type/${type}`);
  const unwrapped = unwrap(res);
  if (!unwrapped) return [];
  if (Array.isArray(unwrapped)) return unwrapped;
  if (Array.isArray(unwrapped.content)) return unwrapped.content;
  return [];
}

export async function saveCustomer(payload) {
  const res = await api.post('/customer/save', payload);
  return unwrap(res);
}

export async function deleteCustomer(id) {
  const res = await api.delete(`/customer/${id}`);
  return unwrap(res);
}
